export default "__VITE_ASSET__MnciXVCX__"